import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

export interface NotificationObject {
  icon?: string;
  description: string;
  routeAction?: RouteObject | Function;
}

export interface RouteObject {
  route: string[];
  params?: { [param: string]: any };
  fragment?: string;
}

@Component({
  selector: 'miq-top-notification',
  templateUrl: './top-notification.component.html',
  styleUrls: ['./top-notification.component.scss'],
  standalone: false,
})
export class TopNotificationComponent {
  @Input()
  public isSuccess;
  @Input()
  public customTitle: NotificationObject;
  @Input()
  public message = '';
  @Input()
  public actions: NotificationObject[];

  @Output()
  public dismiss: EventEmitter<any>;

  constructor(private router: Router) {
    this.dismiss = new EventEmitter();
  }

  public runAction(action: Function | RouteObject) {
    if (action instanceof Function) {
      action();
    } else if (action instanceof Object) {
      this.router.navigate(action.route, {
        fragment: action.fragment ? action.fragment : '',
        queryParams: !!action.params ? action.params : {},
      });
    }
    this.dismiss.emit();
  }
}
